import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from "redux";
import _ from "lodash";
import ActionTypes from "../../../../constants/ActionTypes";
import ApiUrls from "../../../../constants/ApiUrls";
import MiddlewareEntities from "../../../../constants/MiddlewareEntities";
import ProductFactory from "../../../../factories/product/ProductFactory";
import { apiRequest } from "../../api/actions";
import { createErrorNotification, getNotification } from "../../notification/actions";
import { setPageDataProductListAction } from "../../pageData/actions";
import { createSearchParamsProductListAction } from "../../searchParams/actions";
import { setProductsAction, enrichProductsAction, setSearchedProductsAction } from './actions';
import { setLoader } from "../../ui/actions";
import { getDefaultPurchase, getDeviceType, getCosmosInstallmentFromParam } from "../../../../utilites/util";
import { wishListProductChangeAction } from "../../wishList/actions";
import LocalStorageKeys from "../../../../constants/LocalStorageKeys";
import { deselectAllCompareProductsAction } from "../../compareDevices/actions";
import { ProductTypes } from "../../../../constants/ProductTypes";
import { getPreBasket } from "../../preBasket/actions";
import { createFilersListAction } from "../../filters/actions";
import { getFiltersFromProducts } from "../../../../selectors/filtersList";

const getConfigObj = (pathname: string) => {
  if (pathname.includes('Mobilni-telefoni')) return 'phone';
  if (pathname.includes('Tableti')) return 'tablet';
  if (pathname.includes('Satovi-i-narukvice')) return 'watches';
  return undefined;
};

export const getProductsMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);
  switch (action.type) {
  case ActionTypes.PRODUCTS.FETCH:
    next(apiRequest(
      null,
      'GET', ApiUrls.PRODUCTS,
      { ...action.params },
      null,
      MiddlewareEntities.PRODUCTS,
      {}),
    );
    next(setLoader(true, MiddlewareEntities.PRODUCTS));
    next(deselectAllCompareProductsAction());
    break;
  case `${MiddlewareEntities.PRODUCTS} ${ActionTypes.API_SUCCESS}` :
    const purchaseDefault = getDefaultPurchase();
    const cosmosInstallmentDefault = getCosmosInstallmentFromParam();
    const deviceType = getDeviceType();
    const savedWishListProduct = JSON.parse(localStorage.getItem(LocalStorageKeys.SAVED_WISH_LIST_PRODUCTS) ?? '{}');
    next(enrichProductsAction(action.payload.data.products, action.payload.data.pageData));
    next(setPageDataProductListAction(action.payload.data.pageData));

    const products = store.getState().products.items;
    const configObj = getConfigObj(window.location.pathname);
    next(createFilersListAction(getFiltersFromProducts(products, configObj)));

    let defaultParam: any = {};

    if (!window.location.search.match(/(purchase)/g)) {
      if (deviceType === "phone") {
        defaultParam = { purchase: purchaseDefault, cosmosInstallments: cosmosInstallmentDefault };
      }
      else defaultParam = { purchase: purchaseDefault };
    }
    if (window.location.pathname.match(/(Mobilni-telefoni|Mobile-phones)/g)) {
      defaultParam = { purchase: purchaseDefault, cosmosInstallments: cosmosInstallmentDefault };
    }
    if (deviceType === ProductTypes.LAPTOP &&  window.location.pathname.match(/biznis|business/gi)) {
      defaultParam = { purchase: purchaseDefault };
    }
    next(createSearchParamsProductListAction(defaultParam));
    next(getNotification(action.payload.data.session.flashMessages,  MiddlewareEntities.PRODUCTS));
    next(setLoader(false, MiddlewareEntities.PRODUCTS));

    // after redirection from yettel nalog call bff to add product when conditions are met
    if (store.getState().session.user.isLoggedIn && !_.isEmpty(savedWishListProduct)) {
      next(wishListProductChangeAction(savedWishListProduct.status, savedWishListProduct.productId, savedWishListProduct.lang, savedWishListProduct.section, savedWishListProduct.type));
    }
    if (deviceType === ProductTypes.TV || deviceType === ProductTypes.OPTICS_EQUIPMENT) {
      next(getPreBasket());
    }

    break;
  case `${MiddlewareEntities.PRODUCTS} ${ActionTypes.API_ERROR}` :
    next(setLoader(false, MiddlewareEntities.PRODUCTS));
    next(createErrorNotification(action.payload.data,  MiddlewareEntities.PRODUCTS));
    break;
  }
};

export const enrichProductsMiddleware: Middleware =
    (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
      next(action);

      if (action.type === ActionTypes.PRODUCTS.ENRICH) {
        const { products, pageData } = action.payload;
        const { ebillDiscount, greenVoucherDiscount } = pageData;
        const productLine = products[0]?.productLine?.productLine;
        const productsEntities: any[] = [];

        products.map((product: any) => {
          [ProductTypes.PHONE, ProductTypes.TABLET].includes(String(productLine)) ?
            productsEntities.push(ProductFactory.createFromResponse(product, { ebillDiscount, greenVoucherDiscount })) :
            productsEntities.push(ProductFactory.createFromResponse(product));
        });


        next(setProductsAction(productsEntities));
        next(setSearchedProductsAction(productsEntities));
      }
    };

export const productsMiddleware = [getProductsMiddleware, enrichProductsMiddleware];


